export const APP_NAME = 'Baseball Data Viewer';
